import { handleAddItem } from './../../utils/data';
import { AppDispatch } from './../../store';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { LoginPayload, RegisterPayload, RegisterState } from "../../types";

import { handleAuth, handleGetDataByPost } from "../../utils/data"


const initialState: RegisterState = {
    loading: false,
    error: null,
    success: false,
}
export const registerUser = createAsyncThunk('auth/register', async ({ data, navigate, dispatch }: { data: RegisterPayload, navigate: any, dispatch: AppDispatch }) => {
    handleAuth("Authentication/register", data, navigate, dispatch)

})
export const sendOTP = createAsyncThunk('auth/OTP', async (phone: string) => {
    const encodedPhone = encodeURIComponent(phone);
    const res = handleGetDataByPost("", `Authentication/sendOTP?isLogin=true&phone=${encodedPhone}`, "POST");
    return res
})
export const verifyOTP = createAsyncThunk('auth/verifyOTP', async ({ phone, otp }: { phone: string, otp: number | string }) => {
    const encodedPhone = encodeURIComponent(phone);
    const res = handleGetDataByPost("", `Authentication/verifyOTP?phone=${encodedPhone}&otp=${otp}`, "POST");
    return res
})
export const sendOtpRegister = createAsyncThunk('auth/OTPRegister', async (phone: string) => {
    const encodedPhone = encodeURIComponent(phone);
    const res = handleGetDataByPost("", `Authentication/sendOTP?isLogin=false&phone=${encodedPhone}`, "POST");
    return res
})
export const forgetPassword = createAsyncThunk('auth/forget-password', async ({ data }: { data: LoginPayload }) => {
   const res=handleAddItem(data, "Authentication/forgotPassword", "POST");
   return res;

})

const registerSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        resetRegisterState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
        },
    },
    extraReducers: (builder) => {
        // registerUser
        builder
            .addCase(registerUser.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(registerUser.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(registerUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Something went wrong";
            });

        // forgetPassword
        builder
            .addCase(forgetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(forgetPassword.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(forgetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Something went wrong";
            });

        // sendOtpRegister
        builder
            .addCase(sendOtpRegister.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendOtpRegister.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(sendOtpRegister.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Something went wrong";
            });

        // sendOTP
        builder
            .addCase(sendOTP.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendOTP.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(sendOTP.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Something went wrong";
            });
    }
});

export const { resetRegisterState } = registerSlice.actions;
export default registerSlice.reducer;